import { useMutation, useQuery } from 'urql';
import { graphql } from '../../gql/index.ts';
import { MailTemplate } from '../../gql/graphql.ts';
import { MailTemplateEditor } from './MailTemplateEditor.tsx';

interface MailSettingsPageProps {
  companyId: string;
}

const MailSettingsMailTemplateCancelSignUpTemplateQuery = graphql(
  /* GraphQL */ `
    query mailSettingsMailTemplateCancelSignUpTemplateQuery(
      $companyId: String!
    ) {
      company(companyId: $companyId) {
        mailSettings {
          mailTemplateSignUpCanceled {
            subject
            template
          }
        }
      }
    }
  `,
);

const UpdateMailTemplateSignUpCanceledTemplateQuery = graphql(/* GraphQL */ `
  mutation updateMailTemplateSignUpCanceledTemplateQuery(
    $companyId: String!
    $company: UpdateCompanyDto!
  ) {
    updateCompany(companyId: $companyId, company: $company) {
      mailSettings {
        mailTemplateSignUpCanceled {
          subject
          template
        }
      }
    }
  }
`);

export const SignUpCanceledTemplateEditor: React.FC<MailSettingsPageProps> = ({
  companyId,
}) => {
  // TODO: Error handling
  const [{ data }, reExecuteQuery] = useQuery({
    query: MailSettingsMailTemplateCancelSignUpTemplateQuery,
    variables: { companyId },
    pause: companyId === undefined || companyId === null,
  });

  const [, updateCompany] = useMutation(
    UpdateMailTemplateSignUpCanceledTemplateQuery,
  );

  const onFormSubmit = (values: MailTemplate) => {
    updateCompany({
      companyId,
      company: { mailSettings: { mailTemplateSignUpCanceled: values } },
    }).then(() => {
      // TODO: Check for errors and indicate success/failure to UI
      reExecuteQuery();
    });
  };

  return (
    <>
      {data?.company.mailSettings.mailTemplateSignUpCanceled && (
        <MailTemplateEditor
          templateName="Abmeldung"
          companyId={companyId}
          template={data.company.mailSettings.mailTemplateSignUpCanceled}
          onSubmit={onFormSubmit}
        />
      )}
    </>
  );
};
